import { motion } from "framer-motion";
import './coupons.scss';
import { useEffect, useState } from "react";
import copy from "copy-to-clipboard";
import { useNavigate } from "react-router-dom";
import 'animate.css'
import { useNotification } from "../../context/NotificationContext";
import { CouponProp } from "../../interface/interfaces";
import { loadCoupons } from "../../api/requests";
import SkeletonLoader from "../SkeletonLoaders/DefaultLoader";
import EmptyDisplay from "../EmptyDisplay/EmptyDisplay";
import Pagination from "../Pagination/Pagination";

const Coupons=()=>{
    const { notify } = useNotification()
    const navigate = useNavigate()
    const [currentNav, setCurrentNav] = useState<string>('available')
    const [isLoading, setIsLoading] = useState(false)
    // const [coupons, setCoupons] = useState([])

    interface CouponDivision {
        active: CouponProp[];
        inactive: CouponProp[];
    }

    const [couponDivision, setCouponDivision] = useState<CouponDivision>({
        active: [],
        inactive: [],
    });

    const [naviFilter, setNaviFilter] = useState({
        currentPage: 1,
        pageSize: 30,
    })

    const [paginationData, setPaginationData] = useState({
        page: 0,
        size: 0,
        total: 0,
        pages: 0
    })



    function filterOffers(offers: CouponProp[]) {
  const now = new Date();

  const available: CouponProp[] = [];
  const usedOrExpired: CouponProp[] = [];

  for (const offer of offers) {
    const startDate = new Date(offer.start_date);
    const endDate = new Date(offer.end_date);

    const isUsageExceeded = offer.maximum_user_usage > offer.maximum_total_usage;
    const isDateInvalid = now < startDate || now > endDate;

    if (isUsageExceeded || isDateInvalid) {
      usedOrExpired.push(offer);
    } else {
      available.push(offer);
    }
  }

  return {
    available,
    usedOrExpired
  };
}


    const reloadFunc = async () => {
        try {
            setIsLoading(true)

            let { coupons, pageInfo } = await loadCoupons(naviFilter.currentPage, naviFilter.pageSize)


            let {available,usedOrExpired} = filterOffers(coupons)


            setCouponDivision((prev) => {
                return {
                    ...prev,
                    active: available
                }
            })


          

            setCouponDivision((prev) => {
                return {
                    ...prev,
                    inactive: usedOrExpired
                }
            })


            setPaginationData(pageInfo)

        } catch (error: any) {
            notify.error(error.message)
        } finally {
            setIsLoading(false)
        }
    }

    const handleSwitch = (page: string) => {
        setCurrentNav(page);
    }


    const dateFunc = (rawDate: string): string => {
        const date = new Date(rawDate);

        const opts: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        };

        const formatted = date.toLocaleDateString('en-US', opts);
        return formatted;
    };

    const handlePageIncrement = (inc: number) => {
        if (!isLoading) {

            setNaviFilter((prev) => {
                return {
                    ...prev,
                    currentPage: prev.currentPage + inc
                }
            })

        }

    }

    const handleCopy = (text: string) => {
        const success = copy(text);

        if (success) {
            notify.success("Copied!");
        } else {
            notify.error("Failed to copy.");
        }
    };

    const handleApply = (id: string) => {
        navigate(`/cart?coupon_id=${id}`)
    }

    useEffect(() => {
        reloadFunc()
        // eslint-disable-next-line
    }, [naviFilter])



return (
     <div className="couponsection ">


         {isLoading && (
                    <SkeletonLoader count={4}></SkeletonLoader>
                )}


                {!isLoading && (
                    <div className="animate__animated animate__fadeIn animate__fast">

                <div className="txtside">

                    <div className="titleside">
                        <div className="icon box"></div>
                        <div className="titletext">Yayako Coupons & Offers</div>
                    </div>

                    <div className="infotext">
                        When you invite a friend to shop at Yayako, you earn 10% off on your next order. Everyone wins!
                    </div>

                </div>

                <div className="switchbox">

                    <div className="eachSwitch" onClick={() => handleSwitch('available')}>
                        <div className="cicon tag"></div>
                        <div className="text">Available</div>

                        {currentNav === 'available' && (<motion.div layoutId="sw" className="switchdiv" transition={{ type: "spring", stiffness: 500, damping: 30 }}></motion.div>)}

                    </div>


                    <div className="eachSwitch" onClick={() => handleSwitch('unavailable')}>
                        <div className="cicon check"></div>
                        <div className="text">Used & Expired</div>


                        {currentNav === 'unavailable' && (<motion.div layoutId="sw" className="switchdiv" transition={{ type: "spring", stiffness: 500, damping: 30 }}></motion.div>)}


                    </div>


                </div>

                        {currentNav === 'available' && (

                            <>
                                {couponDivision.active.length >= 1 && (
                                    <motion.div layoutId="dtab" transition={{ type: "tween", duration: 0.3 }} className="couponGrid available">

                                        {couponDivision.active.map((data, idx) => (
                                            <div className="eachcoupon animate__animated animate__fadeIn animate__fast" key={idx}>

                                                <div className="couponheader">

                                                    <div className="descinfo">
                                                        <div className="title">{data.offer_name}</div>
                                                    </div>

                                                    <div className="offer">{data.discount_percentage}% OFF</div>
                                                </div>

                                                <div className="desctext">{data.discount_percentage}% off on your order</div>

                                                <ul className="desclist">
                                                    <li>
                                                        Expires: {dateFunc(data.end_date)}
                                                    </li>

                                                    <li>
                                                        For all products.
                                                    </li>
                                                </ul>


                                                <div className="btnp">
                                                    <button className="btn full" onClick={() => handleApply(data.id)}>Apply</button>
                                                    <button className="btn transparent" onClick={() => handleCopy(data.coupon_code)}>Copy</button>
                                                </div>

                                            </div>
                                        ))}

                                    </motion.div>
                                )}



                                {couponDivision.active.length < 1 && (
                                    <EmptyDisplay text={"No active coupons"} icon_class={""}></EmptyDisplay>
                                )}
                            </>

                        )}


                        {currentNav === 'unavailable' && (

                            <>
                                {couponDivision.inactive.length >= 1 && (
                                    <motion.div layoutId="dtab" transition={{ type: "tween", duration: 0.3 }} className="couponGrid unavailable">
                                        {couponDivision.inactive.map((data, idx)=>(
                                        <div className="eachcoupon animate__animated animate__fadeIn animate__fast" key={idx}>

                                            <div className="couponheader">

                                                <div className="descinfo">
                                                    <div className="title">{data.offer_name}</div>
                                                </div>

                                                <div className="offer">{data.discount_percentage}% OFF</div>
                                            </div>

                                            <div className="desctext">{data.discount_percentage}% off on your order</div>

                                            <ul className="desclist">
                                                <li>
                                                    Expires: {dateFunc(data.end_date)}
                                                </li>

                                                <li>
                                                    For all products.
                                                </li>
                                            </ul>


                                            <div className="btnp">
                                                <button className="btn full" >Apply</button>
                                                <button className="btn transparent">Copy</button>
                                            </div>

                                        </div>
                                        ))}

                                    </motion.div>
                                )}



                                {couponDivision.inactive.length < 1 && (
                                    <EmptyDisplay text={"No inactive coupons"} icon_class={""}></EmptyDisplay>
                                )}
                            </>

                        )}


                    </div>
                )}


                <Pagination paginationData={paginationData} handlePageIncrement={handlePageIncrement} setNaviFilter={setNaviFilter}></Pagination>

            </div> 
)
}



export default Coupons;